import { getNodeText } from "@testing-library/react";
import { useEffect, useState, useContext } from "react";
import { TypesValue } from "../contexts/types";
import { SourcesValue } from "../contexts/sources";

const methods = [
  {
    name: "lowercase",
    params: [],
    code: "lowercase()",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "UPPERCASE",
    params: [],
    code: "toUpperCase()",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Capitalize",
    params: [],
    code: "capitalize()",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Append",
    params: [
      { name: "value", displayName: "Text to append", editor: "dynamicText" },
    ],
    code: "append",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Format As",
    params: [
      {
        name: "format",
        displayName: "Format",
        editor: "dropdown",
        editorParams: {
          options: [
            { text: "Phone Number", value: "phone" },
            { text: "Credit Card", value: "creditcard" },
          ],
        },
      },
    ],
    code: "format",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "shorten to",
    params: [
      {
        name: "value",
        displayName: "shorten to",
        editor: "number",
        editorParams: {},
      },
    ],
    code: "shortenTo",
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "find and replace",
    code: "findReplace",
    params: [
      { editor: "dynamicText", name: "find", displayName: "Find" },
      { editor: "dynamicText", name: "replace", displayName: "Replace" },
    ],
    type: "Text",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Contains",
    params: [{ name: "value", displayName: "Contains", editor: "text" }],
    code: "contains",
    type: "Text",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "length",
    params: [],
    code: "length",
    type: "Text",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "is Empty",
    params: [],
    code: "isEmpty()",
    type: "Text",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "is not Empty",
    params: [],
    code: "isNotEmpty()",
    type: "Text",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "is equal to",
    params: [{ name: "value", displayName: "Value", editor: "text" }],
    code: "isEqualTo",
    type: "Text",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "formatted as",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "text",
        help: "See Momentjs docs for possible values here",
        editorParams: {},
      },
    ],
    code: "formattedAs",
    type: "Date",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Add",
    params: [
      {
        name: "_unit",
        displayName: "Unit",
        editor: "dropdown",
        editorParams: {
          default: "month",
          options: [
            { value: "month", text: "Month" },
            { value: "week", text: "Week" },
            { value: "day", text: "day" },
            { value: "seconds", text: "seconds" },
          ],
        },
      },
      { name: "value", displayName: "Value", editor: "number" },
    ],
    code: "add",
    type: "Date",
    list: false,
    returnType: "Date",
    returnList: false,
    async: false,
  },
  {
    name: "Extract",
    params: [
      {
        name: "value",
        displayName: "extract",
        editor: "dropdown",
        editorParams: {
          options: [
            { text: "Year", value: "year" },
            { text: "Month", value: "month" },
            { text: "Day", value: "date" },
            { text: "Day of Week", value: "day" },
            { text: "Hours", value: "hour" },
            { text: "Minutes", value: "minute" },
            { text: "seconds", value: "second" },
          ],
        },
      },
    ],
    code: "extract",
    type: "Date",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "is After",
    params: [
      {
        name: "value",
        displayName: "Date",
        editor: "dynamic",
        editorParams: { type: "Date", list: false },
      },
    ],
    code: "isAfter",
    type: "Date",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "is Before",
    params: [
      {
        name: "value",
        displayName: "Date",
        editor: "dynamic",
        editorParams: { type: "Date", list: false },
      },
    ],
    code: "isBefore",
    type: "Date",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Relative time",
    params: [],
    code: "relative()",
    type: "Date",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "is Empty",
    params: [],
    code: "isEmpty()",
    type: "Date",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Formatted As",
    params: [
      {
        name: "value",
        displayName: "Format Type",
        editor: "dropdown",
        editorParams: {
          options: [
            { text: "$", value: "uscurrency" },
            { text: "1,000", value: "basic" },
          ],
        },
      },
    ],
    code: "format",
    type: "Number",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "is Equal",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "number",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "isEqual",
    type: "Number",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Add",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "dynamic",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "add",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Minus",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "dynamic",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "minus",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Multiply",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "dynamic",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "multiply",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Divide",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "dynamic",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "divide",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Divided Remainder",
    params: [
      {
        name: "value",
        displayName: "Number",
        editor: "number",
        editorParams: { type: "Number", list: false },
      },
    ],
    code: "modulo",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Rounded",
    params: [
      {
        name: "value",
        displayName: "Number of decimal places",
        editor: "number",
      },
    ],
    code: "rounded",
    type: "Number",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Flipped",
    params: [],
    code: "flipped()",
    type: "True/False",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "is Equal",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamic",
        editorParams: { type: "True/False", list: false },
      },
    ],
    code: "isEqual",
    type: "True/False",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Sum",
    params: [],
    code: "sum()",
    type: "Number",
    list: true,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Average",
    params: [],
    code: "average()",
    type: "Number",
    list: true,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Max",
    params: [],
    code: "max()",
    type: "Number",
    list: true,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Min",
    params: [],
    code: "min()",
    type: "Number",
    list: true,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "is Empty",
    params: [],
    code: "isEmpty",
    type: "Number",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "is Not Empty",
    params: [],
    code: "isNotEmpty",
    type: "Number",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "First Item",
    code: "first()",
    params: [],
    type: "*",
    list: true,
    returnType: "*",
    returnList: false,
  },

  {
    name: "Last Item",
    code: "last()",
    params: [],
    type: "*",
    list: true,
    returnType: "*",
    returnList: false,
  },

  {
    name: "Item Number",
    code: "itemNumber",
    params: [
      {
        name: "value",
        displayName: "Item Number",
        editor: "dynamic",
        editorParams: { type: "Number", list: false },
      },
    ],
    type: "*",
    list: true,
    returnType: "*",
    returnList: false,
  },
  {
    name: "Count",
    code: "length()",
    params: [],
    type: "*",
    list: true,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Add",
    code: "add",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamic",
        editorParams: { type: "*", list: false },
      },
    ],
    type: "*",
    list: true,
    returnType: "*",
    returnList: true,
  },
  {
    name: "Remove",
    code: "remove",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamic",
        editorParams: { type: "*", list: false },
      },
    ],
    type: "*",
    list: true,
    returnType: "*",
    returnList: true,
  },
  {
    name: "Includes",
    code: "includes",
    params: [
      {
        name: "value",
        displayName: "Value",
        editor: "dynamic",
        editorParams: { type: "*", list: false },
      },
    ],
    type: "*",
    list: true,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Filter",
    code: "filter",
    params: [
      {
        name: "value",
        displayName: "Filter value",
        editor: "dynamic",
        format: `(item) => ([[value]])`,
        editorParams: {
          sources: [
            {
              code: "item",
              name: "this item's",
              returnType: "*",
              returnList: false,
              params: [],
            },
          ],
        },
        help: "When we run this filter for each item in the list. On the items the return a true value will be kept",
      },
    ],
    type: "*",
    list: true,
    returnType: "*",
    returnList: true,
  },
  {
    name: "Latitude",
    code: "lat",
    params: [],
    type: "Location",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "Longitude",
    code: "lng",
    params: [],
    type: "Location",
    list: false,
    returnType: "Number",
    returnList: false,
  },
  {
    name: "is logged in",
    code: "isLoggedIn()",
    params: [],
    type: "user",
    list: false,
    returnType: "True/False",
    returnList: false,
  },
  {
    name: "Coordinates",
    code: "coordinates",
    params: [],
    type: "Location",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "URL",
    code: "src",
    params: [],
    type: "Image",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Name",
    code: "name",
    params: [],
    type: "Image",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Metadata",
    code: "metadata",
    params: [],
    type: "Image",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Metadata Value",
    code: "getMetadataProp",
    params: [
      {
        name: "prop",
        displayName: "Metadata Property",
        editor: "text",
        editorParams: { type: "Text", list: false },
      },
    ],
    type: "Image",
    list: false,
    returnType: "*",
    returnList: false,
  },
  {
    name: "URL",
    code: "src",
    params: [],
    type: "File",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Name",
    code: "name",
    params: [],
    type: "File",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Metadata",
    code: "metadata",
    params: [],
    type: "File",
    list: false,
    returnType: "Text",
    returnList: false,
  },
  {
    name: "Metadata Value",
    code: "getMetadataProp",
    params: [
      {
        name: "prop",
        displayName: "Metadata Property",
        editor: "text",
        editorParams: { type: "Text", list: false },
      },
    ],
    type: "File",
    list: false,
    returnType: "*",
    returnList: false,
  },
];

export const useMethods = (type, list, extraSources, fields = []) => {
  const [_methods, setMethods] = useState([]);
  const [categories, setCategories] = useState([]);
  const types = useContext(TypesValue);
  const sources = useContext(SourcesValue);
  useEffect(() => {
    if (!type && fields.length === 0) {
      const options = [...extraSources, ...sources];
      const categories = [...new Set(options.map((o) => o.category))].sort();
      setMethods([...extraSources, ...sources]);
      setCategories(categories);
      return;
    }
    if (!type && fields.length > 0) {
      console.log(fields);
      setMethods([...fields]);
      const categories = [...new Set(fields.map((o) => o.category))].sort();
      setCategories(categories);
      return;
    }
    const _type = types.find((x) => x.name === type);
    console.log(type, list);
    let _methods = methods
      .filter((f) => f.type === type && f.list === list)
      .map((x) => ({ ...x, category: "Options" }));
    console.log(_methods);

    if (list) {
      const _listMethods = methods
        .filter((x) => x.type === "*" && x.list)
        .map((f) => {
          return {
            ...f,
            returnType: f.returnType === "*" ? type : f.returnType,
            category: "Options",
          };
        });
      _methods = _methods.concat(_listMethods);
    }
    if (_type && _type.fields) {
      const fieldMethods = Object.keys(_type.fields)
        .map((k) => {
          if (_type.fields)
            return {
              name: _type.fields[k].name,
              code: `get("${k}")`,
              returnType: _type.fields[k].type,
              returnList: list || _type.fields[k].list,
              async: false,
              params: [],
              field: k,
              ofType: _type.name,
              category: "Fields",
            };
        })
        .sort((a, b) => (a.name > b.name ? 1 : -1));
      _methods = _methods.concat(fieldMethods);
    }

    console.log(_methods);
    setMethods(_methods);

    const categories = [...new Set(_methods.map((o) => o.category))].sort();
    setCategories(categories);
  }, [type, list, types]);

  return { options: _methods, categories };
};

export const useAllMethods = (extraSources = []) => {
  const sources = useContext(SourcesValue);

  return [...extraSources, ...sources, ...methods];
};
